var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"pdfview",staticClass:"height-without-header"},[(_setup.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"green"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }